module.exports = __webpack_public_path__ + "img/pasos1-1.fb9aa19d.png";